import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { H2, PrimaryButton, PrimaryButtonV2 } from 'utils';
import { Form, Input, Spin } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { authActions } from 'redux/actions';

const FormItem = Form.Item;
class ForgetPasswordV2 extends Component {
  static propTypes = {
    handleCurrentFormState: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    errors: PropTypes.array,
    resetPassword: PropTypes.func.isRequired,
  };
  onFinish = (values) => {
    const { resetPassword } = this.props;
    resetPassword(values.email);
  };

  onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  render() {
    const { handleCurrentFormState, loading } = this.props;
    return (
      <Spin spinning={loading}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '4px',
            textAlign: 'center',
          }}
        >
          <h3>Passwort zurücksetzen</h3>
          <p>
            Bitte gib deine E-Mail-Adresse an, <br />
            um dein Passwort zurückzusetzen.
          </p>
        </div>
        <Form
          name="reset-password"
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          layout='vertical'
        >
          <FormItem
            name="email"
            label="E-Mail"
            rules={[
              {
                required: true,
                message: 'Bitte gib deine E-Mail-Adresse ein.',
              },
            ]}
            hasFeedback
          >
            <Input type="email" placeholder='Deine E-Mail-Adresse' />
          </FormItem>

          <div className="login-actions" >
              <Link to="#!" onClick={() => handleCurrentFormState('login')}>
                Bereits registriert? Jetzt anmelden!
              </Link>
          </div>

          <FormItem>
            <PrimaryButtonV2 htmltype="submit">Passwort zurücksetzen</PrimaryButtonV2>
          </FormItem>
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, loading, errors } = state.authentication;
  return {
    user,
    loading,
    errors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (user) => dispatch(authActions.resetPassword(user)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ForgetPasswordV2);
